import React, { Component } from "react";
import CreatorAdmin from "../CreatorAdmin";
import CommToolContext from "../../containers/common/comm_tool_context";
import {withRouter} from "react-router-dom";
class CommissioningTool extends Component {
  state = {};
  render() {
    return (
      <CommToolContext.Consumer>
        {context => (
          <React.Fragment>
            <CreatorAdmin {...this.props}/>
          </React.Fragment>
        )}
      </CommToolContext.Consumer>
    );
  }
}
CommissioningTool.contextType = CommToolContext;
export default withRouter(CommissioningTool);
